import React from 'react';
import 'pp-vx/dist/components/core/core';
import 'pp-vx/dist/components/modal/modal';
import 'pp-vx/dist/components/modal/modalAdmin';

export default class OverPanel extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div>
        <div
          className='ppvx_modal-backdrop'
          id={this.props.modalId}
          role='dialog'
          aria-labelledby={this.props.titleId}
          aria-describedby='modalDescription'
          aria-hidden='true'
        >
          <article className='ppvx_modal ppvx_modal--overpanel' tabIndex='-1'>
            <header className='ppvx_modal-header'>
              <div className='ppvx_modal-header__action' />
              <div className='ppvx_modal-header__close'>
                <button
                  className='ppvx_modal-header__close-btn'
                  data-action-close-modal='true'
                  id='hide-my-overpanel'
                  aria-label='close lightbox'
                  tabIndex='0'
                />
              </div>
            </header>
            <section className='ppvx_modal__contents'>
              {this.props.renderModalBody}
            </section>
          </article>
        </div>
      </div>
    );
  }
}
